import { formatForStorage } from '@/utils/dates';

/**
 * Normalizes input date string to ISO format (YYYY-MM-DD)
 * Returns null if input is invalid or empty
 * 
 * @deprecated Consolidated custom parsing logic in mapTransforms.ts:L5-21.
 * Use formatForStorage from '@/utils/dates' directly in the future.
 */
export const normalizeDate = (dateStr: string): string | null => {
    return formatForStorage(dateStr);
};


/**
 * Normalizes empty strings to null for optional text fields
 */
export const normalizeText = (text: string | null | undefined): string | null => {
    if (!text || text.trim() === '') return null;
    return text.trim();
};
